// extracted by mini-css-extract-plugin
export default {"timeSlotContainer":"TimeSlotWrapper_timeSlotContainer__iZaVR"};